import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ColumnFiltersState, PaginationState, SortingState } from '@tanstack/react-table';
import { snakeCase } from 'lodash';

import { Configuration, GetTradeHistoryRequest, TradeHistoryApi } from '../_openapi/portfolio-optimizer';
import { processFilter } from '../widgets/filters/filterUtils';
import { defaultApiConfig } from './defaultApiConfig';

const tradeHistoryApi = new TradeHistoryApi(new Configuration(defaultApiConfig));

export const useTradeHistory = ({
    pagination,
    sorting,
    columnFilters,
}: {
    pagination: PaginationState;
    sorting: SortingState;
    columnFilters: ColumnFiltersState;
}) =>
    useQuery({
        queryKey: ['tradeHistory', 'list', { pagination, sorting, columnFilters }],
        queryFn: () => {
            const query: GetTradeHistoryRequest = {
                ...pagination,
            };

            if (sorting.length) {
                query.sortLabel = snakeCase(sorting[0].id);
                query.sortDesc = sorting[0].desc;
            }

            if (columnFilters.length) {
                query.filter = columnFilters.map(processFilter);
            }

            return tradeHistoryApi.getTradeHistory(query);
        },
        placeholderData: keepPreviousData,
    });
